import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../app/hooks";
import {
	clearSchool,
	setDistrict,
	setSchool,
	setSchools,
	transitionSchool,
} from "../../../app/userSlice";
import NamedEntity from "../../../interfaces/NamedEntity";
import {
	useGetSchoolPickerOptionsQuery,
	useMakeSchoolSelectionMutation,
} from "../../schools/schoolsApiSlice";
import Picker from "./Picker";

export default function SchoolPicker() {
	const { school } = useAppSelector((state) => state.user);
	const selectSchoolURL = "/selectSchool";

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const schoolsResult = useGetSchoolPickerOptionsQuery();
	const schools = schoolsResult.data;

	const [callSelectSchool] = useMakeSchoolSelectionMutation();

	useEffect(() => {
		if (schools) dispatch(setSchools(schools));
	}, [schools]);

	function handleSelectSchool(school: NamedEntity) {
		dispatch(transitionSchool());
		callSelectSchool(school.id)
			.unwrap()
			.then((district) => {
				dispatch(
					setSchool({
						id: school.id,
						name: school.name,
					})
				);
				dispatch(setDistrict(district ? { id: district.id, name: district.name } : null));
				navigate("/adminHome");
			})
			.catch((error) => {
				dispatch(clearSchool());
				navigate(selectSchoolURL);
			});
	}

	if (!schools || !school) return null;

	return (
		<Picker
			currentOption={school}
			options={schools}
			label={"schools"}
			navigateURL={selectSchoolURL}
			onClick={handleSelectSchool}
		/>
	);
}
